'use client'
import { ButtonLink, LogoTypeBrand } from '@repo/shared/components'
import { CenterBox, Row } from '@repo/ui/components'
import { useLanguage } from '@repo/shared/hooks'
import { useTheme } from 'next-themes'
import Image from 'next/image'
import { twMerge } from 'tailwind-merge'

interface IAuthHeaderLayoutProps {
  isAgent?: boolean
  className?: string
}

export const AuthHeaderLayout = (props: IAuthHeaderLayoutProps) => {
  const { isAgent, className } = props
  const { resolvedTheme } = useTheme()
  const locale = useLanguage()

  return (
    <CenterBox className={twMerge('pt-3xl pb-xs px-xl', className)}>
      <ButtonLink href='/' variant='transparent' buttonClassName='!p-0'>
        <Row>
          <Row className='w-20'>
            <div className='w-[120px] h-10 relative flex items-center justify-center'>
              <LogoTypeBrand
                alt='logo'
                fill
                sizes='(max-width: 768px) 120vw, 100px'
                priority
                className='object-contain h-auto '
              />
            </div>
          </Row>
          {isAgent && resolvedTheme && (
            <Image
              src={`/logo-agents-${resolvedTheme}-${locale}.svg`}
              alt='logo'
              priority
              width={42}
              height={11}
              className={twMerge(
                'object-contain',
                locale === 'fa' ? 'mt-sm' : 'mt-2xs',
              )}
            />
          )}
        </Row>
      </ButtonLink>
    </CenterBox>
  )
}
